export default __webpack_public_path__ + "static/media/group-16.e1c0453f.svg";